import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';  // <--- THIS LINE MUST BE HERE AND UNCOMMENTED
import App from './App';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);